/* eslint-disable */
import {lista, pegaDados, processar} from '../../../services/GenericAPI'
import {EventoAdministrativo} from "../../../models/cadastro/evento_administrativo";
import {EventoAdministrativoSCH} from "../../../search/EventoAdministrativoSCH"
import {Filtro} from "../../../models/filtro/filtro";

const url = '/evento_administrativo';

const state = {
  evento_administrativo: new EventoAdministrativo(),
  all: [],
  allList: [],
  filtro: new Filtro()
};

const getters = {
  pegaEventoAdministrativo: (state) => {
    return state.evento_administrativo
  },
  pegaFiltro: (state) => {
    return state.filtro
  },
  listaEventoAdministrativo: (state) => {
    return state.allList
  },
  listaEventoAdministrativoSemFiltro: (state) => {
    return state.all
  },
};

const actions = {
  async setAllListEventoAdministrativo({commit}) {
    const list = (await lista(url + '/all')).data;
    commit('SET_ALL_LISTA', list)
  },
  searchHistoricoPadrao({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.addSearch(['descricao' ],
      '%'+search+'%',
      'ilike'
    )
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', EventoAdministrativoSCH(perPage))
  },

  setEventoAdministrativo({commit}, evento_administrativo) {
    commit('SET_EVENTO_ADMINISTRATIVO', evento_administrativo)
  },

  async setAllEventoAdministrativo ({ commit }, {onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url+'/get', state.filtro)).data;
      commit('SET_EVENTOS_ADMINISTRATIVO', list);
      onSucesso()
    } catch (error) {
      onErro()
    }
  },
  async processarEventoAdministrativo ({ commit }, {acao, onSucesso,onErro }) {
    try {
      let res = await processar(url, state.evento_administrativo, acao);
      this.dispatch('geral/setMsgSuccess', res.data.message);
      onSucesso()
    } catch (error) {
      this.dispatch('geral/setObjMsgError', error.response.data);
      onErro()
    }
  }
};

const mutations = {
  SET_ALL_LISTA (state, eventos_administrativo) {
    state.allList = eventos_administrativo
  },
  SET_EVENTO_ADMINISTRATIVO (state, eventos_administrativo) {
    state.evento_administrativo = eventos_administrativo
  },
  SET_EVENTOS_ADMINISTRATIVO (state, eventos_administrativo) {
    state.all = eventos_administrativo
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
